import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import UeberUns from "@/pages/UeberUns";
import Investmentfokus from "@/pages/Investmentfokus";
import Ablauf from "@/pages/Ablauf";
import Werte from "@/pages/Werte";
import Faq from "@/pages/Faq";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import Presse from "@/pages/Presse";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import CookieBanner from "@/components/CookieBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="/investmentfokus" element={<Investmentfokus />} />
          {/* Legacy slug kept for inbound links */}
          <Route path="/taetigkeitsfelder" element={<Investmentfokus />} />
          <Route path="/ablauf" element={<Ablauf />} />
          <Route path="/werte" element={<Werte />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightArticle />} />
          <Route path="/presse" element={<Presse />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(212, 175, 55, 0.3)",
            color: "#ffffff",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
